<sd-icon class="icon-size-s" [type]="iconTypes.ATTENTION" />
<ng-content></ng-content>
